import { FieldTypes } from './field-types';

export interface FieldInfo {
  id?: string;
  placeholder?: any;
  fieldName: string;
  label: string;
  showLabel?: boolean;
  labelOnly?: boolean;
  fieldType?: FieldTypes;
  required?: boolean;
  fieldLength?: number;
  minChar?: number;
  maxChar?: number;
  decimal?: number;
  pattern?: string;
  validations?: any;
  currencyType?: string;
  allowDash?: boolean;
}
